module.exports = __webpack_public_path__ + "img/insights-header.7a85d990.svg";